export default __webpack_public_path__ + "static/media/bullets.87fe174f.svg";